import {Component} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Observable, skip, tap} from "rxjs";
import {distinctUntilChanged, map, switchMap} from "rxjs/operators";
import {TranslocoService} from "@ngneat/transloco";
import {GoogleAnalyticsService} from "./google-analytics/service/analytics.service";
import {CartService} from "./webshop/cart/state/service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'bomo';
  translationChange$: Observable<boolean>;

  constructor(private router: Router,
              private translationService: TranslocoService,
              private cartService: CartService,
              private route: ActivatedRoute,
  ) {


    this.translationChange$ = this.translationService.langChanges$.pipe(
      distinctUntilChanged(),
      skip(1),
      tap((locale) => {
        if (!window['noRedir']) {
          localStorage.setItem('language', locale);
          this.cartService.clearCart();

          const parts = window.location.pathname.split('/');
          // Keep language prefix in sync for both webshop and admin (/hu/... → /en/...).
          if (parts.length >= 2 && (parts[1] === 'hu' || parts[1] === 'en')) {
            parts[1] = locale;
            window.location.pathname = parts.join('/') || '/' + locale;
          } else {
            window.location.pathname = '/' + locale + window.location.pathname;
          }
        }
      }),
      map(() => true)
    );
  }

  ngOnInit() {
  }
}
